import React from "react";
import { Box, Typography, Paper, Chip, Grid, Button, IconButton } from "@mui/material";
import { useSelector } from "react-redux";
import MicIcon from "@mui/icons-material/Mic";

import CloudDownloadIcon from "@mui/icons-material/CloudDownload";

const PersonCommentManager = ({ prevStep, handleSubmit, commentData }) => {
  const user = useSelector((state) => state.auth.user); // User data from Redux store

  return (
    <Box sx={{ pl: 4, pr: 4, ml: 2 }}>
      <Chip
        variant='contained'
        sx={{
          fontSize: "14px",
          backgroundColor: "#F2F6FF",
          color: "blue",
        }}
        label='Daily Log'
        size='small'
      />
      <Typography sx={{ fontSize: "24px", color: "black", fontWeight: "bold" }}>
        Child and Young Person Debrief{" "}
      </Typography>
      <Typography variant='subtitle2' sx={{ color: "#757575" }}>
        Date: {new Date().toLocaleDateString()} &nbsp; • &nbsp;{" "}
        <span style={{ color: "#1751D0" }}>{user.username}</span>
      </Typography>
      <Box sx={{ borderBottom: "1px solid #E0E0E0", mt: 2, mb: 2 }} />

      <Grid container spacing={2}>
        <Grid item lg={8} md={8}>
          <Typography sx={{ fontSize: "16px", fontWeight: "bold", color: "black" }}>
            Child or Young Person’s comments
          </Typography>
          {/* Description */}
          <Typography variant='body2' sx={{ color: "#757575", mb: 2 }}>
            Please can you put into words what you felt and how you feel about the physical intervention? (You can ask
            the staff member to write if you wish).
          </Typography>
          {commentData?.map((record, index) => (
            <Paper
              key={index}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: 1,
                mb: 1,
                borderRadius: 2,
                border: "1px solid #ccc",
              }}
            >
              <Typography sx={{ fontSize: "14px", color: "black" }}>
                {record.audio ? (
                  record.behavior
                ) : (
                  <>
                    {record.behavior}
                    <br />
                    {record.note}
                  </>
                )}
              </Typography>

              <Box>
                {record.audio && (
                  <>
                    <IconButton onClick={() => window.open(record.audio, "_blank")}>
                      <MicIcon color='primary' />
                    </IconButton>
                    <IconButton onClick={() => window.open(record.audio, "_blank")}>
                      <CloudDownloadIcon color='primary' />
                    </IconButton>
                  </>
                )}
              </Box>
            </Paper>
          ))}
        </Grid>
      </Grid>

      {/* Footer Actions */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 2,
          position: "sticky",
          bottom: 0,
          background: "#fff",
          padding: 2,
          zIndex: 10,
        }}
      >
        <Button variant='outlined' color='primary' onClick={prevStep}>
          Previous
        </Button>
        <Button
          variant='contained'
          color='primary'
          onClick={() => {
            handleSubmit(); // Call the function properly
          }}
        >
          Close
        </Button>
      </Box>
    </Box>
  );
};

export default PersonCommentManager;
